import projectSlider from '../components/project-slider'

export default {
	namespace: 'project',
	beforeEnter() {

	},
	afterEnter(barba) {
		console.log('View: project')
		projectSlider(barba)
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
